var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#393939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3845_17105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6654 29.3802C32.6654 29.8222 32.4898 30.2462 32.1772 30.5587C31.8646 30.8713 31.4407 31.0469 30.9987 31.0469H15.9987C15.5567 31.0469 15.1327 30.8713 14.8202 30.5587C14.5076 30.2462 14.332 29.8222 14.332 29.3802V20.2135C14.332 19.7715 14.5076 19.3476 14.8202 19.035C15.1327 18.7225 15.5567 18.5469 15.9987 18.5469H19.332L20.9987 16.0469H25.9987L27.6654 18.5469H30.9987C31.4407 18.5469 31.8646 18.7225 32.1772 19.035C32.4898 19.3476 32.6654 19.7715 32.6654 20.2135V29.3802Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6654 29.3802C32.6654 29.8222 32.4898 30.2462 32.1772 30.5587C31.8646 30.8713 31.4407 31.0469 30.9987 31.0469H15.9987C15.5567 31.0469 15.1327 30.8713 14.8202 30.5587C14.5076 30.2462 14.332 29.8222 14.332 29.3802V20.2135C14.332 19.7715 14.5076 19.3476 14.8202 19.035C15.1327 18.7225 15.5567 18.5469 15.9987 18.5469H19.332L20.9987 16.0469H25.9987L27.6654 18.5469H30.9987C31.4407 18.5469 31.8646 18.7225 32.1772 19.035C32.4898 19.3476 32.6654 19.7715 32.6654 20.2135V29.3802Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5013 27.7135C25.3422 27.7135 26.8346 26.2212 26.8346 24.3802C26.8346 22.5393 25.3422 21.0469 23.5013 21.0469C21.6604 21.0469 20.168 22.5393 20.168 24.3802C20.168 26.2212 21.6604 27.7135 23.5013 27.7135Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5013 27.7135C25.3422 27.7135 26.8346 26.2212 26.8346 24.3802C26.8346 22.5393 25.3422 21.0469 23.5013 21.0469C21.6604 21.0469 20.168 22.5393 20.168 24.3802C20.168 26.2212 21.6604 27.7135 23.5013 27.7135Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3845_17105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13.5469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a98c40ae81af99ff69f7fb64cfcce708.svg";
export { ForwardRef as ReactComponent };